export const price = {
  methods: {
    formatPrice (amount) {
      if (!amount) {
        amount = 0
      }

      const c = amount.toLocaleString('uk-UK', {
        style: 'currency',
        currency: 'UAH'
      })

      return c.replace('грн', '')
    },

    formatPriceWithCurrency (amount) {
      if (!amount) {
        amount = 0
      }

      return amount.toLocaleString('uk-UK', {
        style: 'currency',
        currency: 'UAH'
      })
    },
    actualEtalonPrice (prices) {
      let currentPrice = 0

      for (const price of prices) {
        if (currentPrice === 0 && price.type === 'etalon_base') {
          currentPrice = price.value
        }
        if (price.type === 'etalon_special') {
          currentPrice = price.value
        }
      }

      return currentPrice
    },
    priceWithDiscount (price, discount) {
      console.log(price, discount)
      return (price * ((100 - discount) / 100)).toFixed(2)
    }
  }
}
